<template>
  <div id="app">
    <navbar></navbar>
    <transition name="fade" mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>

<script>
import navbar from './components/navbar.vue';
export default {
  name: 'HomeView',
  components: {
    navbar
  }
}
</script>


<style lang="scss">
@import '@/styles/variables.scss';

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
}

body {
  font-family: $font-family;
  background: $bg-primary;
  color: $text-primary;
  line-height: 1.6;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#app {
  min-height: 100vh;
}

a {
  color: $primary-color;
  text-decoration: none;
  transition: color 0.2s ease;
  
  &:hover {
    color: $primary-dark;
  }
}

::selection {
  background: rgba($primary-color, 0.2);
  color: $primary-dark;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.slide-enter-active,
.slide-leave-active {
  transition: all 0.3s ease;
}

.slide-enter,
.slide-leave-to {
  transform: translateY(20px);
  opacity: 0;
}

.container {
  @media (max-width: $breakpoint-sm) {
    padding-left: 16px;
    padding-right: 16px;
  }
}

.btn {
  transition: all 0.3s ease;
  
  &:focus {
    box-shadow: 0 0 0 3px rgba($primary-color, 0.2);
  }
}

.form-control {
  transition: all 0.3s ease;
  
  &:focus {
    border-color: $primary-color;
    box-shadow: 0 0 0 3px rgba($primary-color, 0.1);
  }
}

.card {
  border: none;
  border-radius: $radius-lg;
  box-shadow: $shadow-card;
  transition: all 0.3s ease;
  
  &:hover {
    box-shadow: $shadow-card-hover;
  }
}

.badge {
  font-weight: 500;
  padding: 0.4em 0.8em;
  border-radius: $radius-sm;
}

.alert {
  border: none;
  border-radius: $radius-md;
}

.modal-backdrop {
  background: rgba($bg-dark, 0.5);
  backdrop-filter: blur(4px);
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: $bg-secondary;
  border-radius: $radius-full;
}

::-webkit-scrollbar-thumb {
  background: $primary-light;
  border-radius: $radius-full;
  
  &:hover {
    background: $primary-color;
  }
}

::placeholder {
  color: $text-muted;
  opacity: 1;
}

img {
  max-width: 100%;
  height: auto;
}

button {
  font-family: inherit;
}

input, textarea, select {
  font-family: inherit;
}

h1, h2, h3, h4, h5, h6 {
  color: $text-primary;
  font-weight: 600;
  line-height: 1.3;
}

p {
  margin-bottom: 1rem;
}

.text-primary {
  color: $primary-color !important;
}

.text-secondary {
  color: $text-secondary !important;
}

.bg-primary-gradient {
  background: $primary-gradient !important;
}

.shadow-primary {
  box-shadow: $shadow-primary !important;
}

.rounded-lg {
  border-radius: $radius-lg !important;
}

.rounded-xl {
  border-radius: $radius-xl !important;
}
</style>
